var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39314 10.3684L12.7079 4.44745M6.39314 10.7631V12.5212C6.39314 14.3954 6.39314 15.3317 6.99093 15.4817C7.58873 15.6317 8.21852 14.8517 9.47809 13.2925L10.182 12.342M5.13693 4.58877L11.3009 1.85724C13.8622 0.722 15.1428 0.15438 15.9595 0.723579C16.7762 1.29278 16.543 2.59065 16.0757 5.1856L15.2725 9.65551C14.9669 11.3521 14.8145 12.1999 14.1401 12.5702C13.4656 12.9404 12.5892 12.6562 10.837 12.0878L5.47792 10.3494C2.201 9.28683 0.562532 8.75553 0.50191 7.71265C0.439605 6.67057 2.00566 5.97585 5.13693 4.58877Z",
    stroke: "#2E2C27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail3);
export default __webpack_public_path__ + "static/media/email-3.856be5c287fb8458fedc4870dbf729dd.svg";
export { ForwardRef as ReactComponent };